export { default as Navbar } from "./Navbar/Navbar";
export { default as HomeSection } from "./HomeSection/HomeSection";
export { default as PricingSection } from "./PricingSection/PricingSection";
export { default as ProcessSection } from "./ProcessSection/ProcessSection";
export { default as PartnerSection } from "./PartnerSection/PartnerSection";
export { default as AboutSection } from "./AboutSection/AboutSection";
export { default as SupportSection } from "./SupportSection/SupportSection";
export { default as SubscribeSection } from "./SubscribeSection/SubscribeSection";
